"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _MenuContent = _interopRequireDefault(require("./MenuContent"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * LargeMenuWithImage
 * 大型選單 + 圖片：樣式 3
 * @returns {React.ReactElement}
 */
var LargeMenuWithImage = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LargeMenuWithImage, _React$Component);

  var _super = _createSuper(LargeMenuWithImage);

  function LargeMenuWithImage(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LargeMenuWithImage);
    _this = _super.call(this, props);
    _this.state = {
      visible: false
    };
    return _this;
  }

  (0, _createClass2["default"])(LargeMenuWithImage, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var visible = this.state.visible;
      var onVisibleChange = this.props.onVisibleChange;

      if (prevState.visible !== visible && onVisibleChange) {
        onVisibleChange(visible);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          pages = _this$props.pages,
          renderChildren = _this$props.renderChildren,
          menuSettings = _this$props.menuSettings,
          submenuSettings = _this$props.submenuSettings,
          style = _this$props.style;
      var visible = this.state.visible;
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: _objectSpread({
          position: 'relative'
        }, style),
        onMouseEnter: function onMouseEnter() {
          return _this2.setState({
            visible: true
          });
        },
        onMouseLeave: function onMouseLeave() {
          return _this2.setState({
            visible: false
          });
        }
      }, renderChildren(), /*#__PURE__*/_react["default"].createElement(_MenuContent["default"], {
        visible: visible,
        pages: pages,
        menuSettings: menuSettings,
        submenuSettings: submenuSettings
      }));
    }
  }]);
  return LargeMenuWithImage;
}(_react["default"].Component);

var _default = LargeMenuWithImage;
exports["default"] = _default;